var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component, Prop } from "vue-property-decorator";
import GlobalVue from "../globalVue";
import { mapActions } from "vuex";
import StockWarning from "../components/main/StockWarning.vue";
import SalesAnalysis from "../components/main/SalesAnalysis.vue";
import PendingBusiness from "../components/main/PendingBusiness.vue";
import CertificateWarn from "../components/main/CertificateWarn.vue";
import IncomeExpenses from "../components/main/IncomeExpenses.vue";
import NewsNotice from "../components/main/NewsNotice.vue";
import WorkDynamic from "../components/main/WorkDynamic.vue";
import JoinCustomerWarm from "../components/main/JoinCustomerWarm.vue";
import { toDetail } from "../helper/util";
import { EMessageTypeConfig } from "../enum/EBillType";
import clientManage from "./client/List.vue";
var Main = (function (_super) {
    __extends(Main, _super);
    function Main() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.showJoinModel = true;
        return _this;
    }
    Main.prototype.hiddenJoinModel = function () {
        this.showJoinModel = false;
    };
    Main.prototype.toWarnDetail = function (row) {
        this.$refs.StockWarning.showWarnModal(row.notice_params.warning_type, '1', row.notice_params.warning_id);
    };
    Main.prototype.uploadAuth = function (menu, noNeedAuth) {
        var cprops, cb;
        switch (menu.power_code.toString()) {
            case "6002":
                cprops = {
                    porder: ["document_etime", "asc"],
                    defaultFormData: {
                        expire_status: '2,3'
                    }
                };
                cb = function () {
                    GlobalVue.$emit("LicenseManage:etimeSort");
                };
                break;
            case "12001":
                cb = function (e) {
                    e.comp.status = "2";
                };
                break;
            case "12002":
                cb = function (e) {
                    e.comp.activeName = "1";
                };
                break;
            default:
                cprops = {};
                cb = function () {
                };
        }
        ;
        this.$emit('open-page', __assign({}, menu, cprops, { cb: cb }));
    };
    Main.prototype.toMenuPage = function (pageAuth, menu) {
        this.updateHomeShow(false);
    };
    Main.prototype.toBillDetail = function (item) {
        var _this = this;
        this.getAuth(item.power_key).then(function (pageAuth) {
            if (pageAuth && pageAuth.Auth.LookDetail) {
                _this.updateHomeShow(false);
                toDetail(item.order_type, item.order_id);
            }
            else {
                _this.$message.error(EMessageTypeConfig[item.order_type].title + " 没有查看详情权限");
            }
        });
    };
    Main.prototype.toClient = function (businessid) {
        this.updateHomeShow(false);
        GlobalVue.$emit("addTab", {
            component: clientManage,
            title: '客户管理',
            showExist: true,
            name: 'client_',
            cprops: {
                businessid: businessid
            }
        });
    };
    __decorate([
        Prop({
            required: true
        })
    ], Main.prototype, "pageAuth", void 0);
    Main = __decorate([
        Component({
            components: {
                StockWarning: StockWarning,
                PendingBusiness: PendingBusiness,
                CertificateWarn: CertificateWarn,
                IncomeExpenses: IncomeExpenses,
                NewsNotice: NewsNotice,
                WorkDynamic: WorkDynamic,
                SalesAnalysis: SalesAnalysis,
                JoinCustomerWarm: JoinCustomerWarm
            },
            methods: __assign({}, mapActions(["getAuth", "updateHomeShow"]))
        })
    ], Main);
    return Main;
}(Vue));
export default Main;
